import React, {useState} from "react";
import {Backdrop, Box, DialogContent, Fade, Grid, IconButton, Modal, Paper,} from "@mui/material";
import {Close} from "@mui/icons-material";
import {keyframes} from "@mui/system";

export interface PopUpProps {
	title: string
	content: React.ReactNode
	open: boolean
	setOpen: (state: boolean) => void,
	size?: 'sm' | 'md' | 'lg' | 'xl' | 'max',
	onClose?: () => void
	uid?: string
}

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	maxWidth: '75%',
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	px: 1,
	pt: 1,
	pb: 0.5,
	maxHeight: '100%',
	overflow: 'auto',
	opacity: 0.96,
	borderRadius: '4px',
};

const zoomFeedback = keyframes({
	'0%': {transform: 'scale(1)'},
	'50%': {transform: 'scale(0.99)'},
	'100%': {transform: 'scale(1)'},
});

export const PopUp: React.FC<PopUpProps> = ({title, content, open, setOpen, size, onClose}) => {
	const sz = {'sm': '250px', 'md': '400px', 'lg': '600px', 'xl': '960px', 'max': '95%'}[size || 'md'];
	const [backdropClicked, setBackdropClicked] = useState(false);

	return (
		<Modal open={open} onClose={() => {
		}}><>
			<Backdrop open={open}
			          sx={{
				          zIndex: (theme) => theme.zIndex.drawer + 1,
				          backdropFilter: 'blur(0.17rem)',
			          }}

			          onClick={() => {
				          // Single click: provide visual feedback (zoom in/out) without closing
				          setBackdropClicked(false);
				          // allow re-triggering the animation even if already active
				          setTimeout(() => setBackdropClicked(true), 0);
				          // turn it off after animation duration
				          setTimeout(() => setBackdropClicked(false), 260);
			          }}
			          onDoubleClick={() => {
				          if (setOpen != null) {
					          setOpen(false);
				          }
				          if (onClose != null) {
					          onClose();
				          }
			          }}
			>
			</Backdrop>

			<Fade in={open} timeout={100}>
				<Box sx={{
					...style,
					zIndex: (theme) => theme.zIndex.drawer + 1,
					maxWidth: '95%',
					width: sz
				}} component={Paper} elevation={2}>
					<Box sx={{
						width: '100%',
						animation: backdropClicked ? `${zoomFeedback} 240ms ease-in-out` : 'none',
						transformOrigin: 'center',
					}}>
						<Grid size={12}>
							<Grid container justifyContent={'space-between'} alignItems={'center'}>
								<Grid size={'grow'}>
									<Grid>{title}</Grid>
								</Grid>
								<Grid>
									<Grid container justifyContent={'end'}>
										<IconButton size={'small'} onClick={() => {
											setOpen(false);
											if (onClose) onClose();
										}}>
											<Close/>
										</IconButton>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid container maxHeight={'70vh'} sx={{overflow: 'auto', p: 0}}>
							<Grid size={12} sx={{
								maxHeight: '65%',
								overflow: 'auto',
							}}>

								<DialogContent sx={{
									maxWidth: '100%',
									width: '100%',
									overflow: 'auto',
									p: 1,
								}}>{content}</DialogContent>
							</Grid>
						</Grid>
					</Box>
				</Box>
			</Fade>
		</>
		</Modal>
	);
};